import { SYSTEM_MODES } from "./createAppSlice";

// Draft/live selection rules for collections, shared by the collections slice and by features that
// need to read collections outside the store (e.g. the legacy routing tables check) so they can't drift.

// The draft listing is in effect whenever a draft exists (even if it has no instances yet) or it has entries.
export const getEffectiveConfigRef = ({ configRef, draftConfigRef } = {}, draft) => {
  const hasDraftRef = !!draftConfigRef && (!!draft || Object.keys(draftConfigRef).length > 0);
  return hasDraftRef ? draftConfigRef : configRef;
};

// What the user sees: the effective listing while editing, the live listing otherwise.
export const getCurrentConfigRef = (collections, { draft, systemMode }) =>
  systemMode === SYSTEM_MODES.EDIT ? getEffectiveConfigRef(collections, draft) : collections?.configRef;

// A non-empty draft config wins over the live config of a single collection instance.
export const getEffectiveCollectionConfig = ({ config, draftConfig } = {}) =>
  Object.keys(draftConfig || {}).length ? draftConfig : config;

// What the user sees for one instance: the effective config while editing, the live config otherwise.
export const getCurrentCollectionConfig = (collection, systemMode) =>
  systemMode === SYSTEM_MODES.EDIT ? getEffectiveCollectionConfig(collection) : collection?.config;
